import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { updateContractPrice } from "../../pricing-values/thunks/updateContractPrice";
import { ContractFunnel } from "../../../types/interfaces";
import { PricingState } from "../pricingSlice";
import { createContractFunnelHash } from "../utils/createContractFunnelHash";

export const addContractPricingReducers = (builder: ActionReducerMapBuilder<PricingState>) => {
  builder
    .addCase(updateContractPrice.pending, (state) => {
      // Handle pending state if needed
    })
    .addCase(updateContractPrice.fulfilled, (state, action) => {
      const { newPrice, isSuccess, errorMessage, contractFunnelId, contractIdentifier } =
        action.payload;

      const existingUpdatedIndex = state.updatedContractFunnels.findIndex(
        ucf => ucf.id === contractFunnelId && ucf.contractIdentifier === contractIdentifier
      );
      if (existingUpdatedIndex === -1) return;

      const targetContractFunnel: ContractFunnel =
        state.updatedContractFunnels[existingUpdatedIndex];

      // isSuccess=false (produit inéligible ou erreur de tarif) : on garde la carte
      // désactivée avec son message, sans mettre à jour le prix (consigne).
      if (isSuccess === false) {
        targetContractFunnel.isSuccess = false;
        targetContractFunnel.errorMessage = errorMessage ?? undefined;
        return;
      }

      // Recalcul OK : prix mis à jour, carte réactivée, message effacé.
      targetContractFunnel.isSuccess = true;
      targetContractFunnel.errorMessage = undefined;
      targetContractFunnel.pricing = newPrice;
      targetContractFunnel.hash = '';
      targetContractFunnel.hash = createContractFunnelHash(targetContractFunnel);
    })
    .addCase(updateContractPrice.rejected, (state, action) => {
      // Handle rejected state if needed
    });
};
